import { Box, BoxProps } from "@chakra-ui/react";

type DataCountDisplayProps = {
  count: number;
  maxDataCount: number;
} & BoxProps;

export const DataCountDisplay = (props: DataCountDisplayProps) => {
    const { count, maxDataCount, borderColor, borderRadius, borderStyle, borderWidth, color, fontSize, ...rest } = props;

    const isMaxReached = count >= maxDataCount;
    const resolvedBorderColor = borderColor ?? (isMaxReached ? "red" : "darkgray");
    const resolvedColor = color ?? (isMaxReached ? "red" : "darkgray");

    return (
        <Box
            fontSize={fontSize ?? "small"}
            borderRadius={borderRadius ?? 5}
            borderWidth={borderWidth ?? 1}
            borderStyle={borderStyle ?? "solid"}
            borderColor={resolvedBorderColor}
            color={resolvedColor}
            padding="0 5px"
            {...rest}>
            {count} / {maxDataCount}
        </Box> 
    );
}